module.exports = __webpack_public_path__ + "static/img/ghoul2.061bc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/ghoul2.png
// module id = UUfv
// module chunks = 0